import React, { useState } from 'react';
import { templates, Template } from '../data/templates';
import Portal from './Portal';

interface TemplatePickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (template: Template) => void;
  selectedTemplateId?: string;
}

export default function TemplatePickerModal({
  isOpen,
  onClose,
  onSelect,
  selectedTemplateId,
}: TemplatePickerModalProps) {
  const [searchQuery, setSearchQuery] = useState('');

  if (!isOpen) return null;

  const filteredTemplates = templates.filter((template) =>
    template.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelect = (template: Template) => {
    onSelect(template);
    onClose();
  };

  return (
    <Portal>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-bg border border-white/20 rounded-xl p-6 w-full max-w-[min(900px,calc(100vw-2rem))] max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-white">Select a Template</h2>
          <button
            onClick={onClose}
            className="text-white/60 hover:text-white transition-colors text-2xl"
          >
            ×
          </button>
        </div>

        <div className="mb-4">
          <input
            type="text"
            placeholder="Search templates..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-black/50 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/50"
          />
        </div>

        <div className="auto-grid">
          {filteredTemplates.map((template) => (
            <button
              key={template.id}
              onClick={() => handleSelect(template)}
              className={`p-4 rounded-lg border-2 transition-colors ${
                selectedTemplateId === template.id
                  ? 'border-white bg-white/10'
                  : 'border-white/20 bg-white/5 hover:border-white/40'
              }`}
            >
              <div className="aspect-[9/16] rounded-lg overflow-hidden mb-2 bg-white/10">
                <img
                  src={template.thumbnailUrl}
                  alt={template.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    // Fallback to placeholder if image doesn't exist
                    (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="356"%3E%3Crect fill="%23333" width="200" height="356"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="14" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3ETemplate%3C/text%3E%3C/svg%3E';
                  }}
                />
              </div>
              <p className="text-white text-sm font-medium text-center">{template.name}</p>
            </button>
          ))}
        </div>

        {filteredTemplates.length === 0 && (
          <div className="text-center py-8 text-white/60">
            No templates found matching "{searchQuery}"
          </div>
        )}
      </div>
      </div>
    </Portal>
  );
}

